<template>
<!--	<v-dialog-->
<!--			:value="isDialogRemove"-->
<!--			content-class="dialogWrapper"-->
<!--			persistent-->
<!--			:width="width"-->
<!--	>-->
<!--		<div class="dialogWrap">-->
<!--			<div class="dialogTitle">-->
<!--				<span v-html="titleRemove"></span>-->
<!--				<v-btn-->
<!--						icon-->
<!--						color="green"-->
<!--						type="button"-->
<!--						@click="onClose('close')"-->
<!--				>-->
<!--					<svg-sprite width="20" height="20" icon-id="close" />-->
<!--				</v-btn>-->
<!--			</div>-->
<!--			<div class="dialogMain">-->
<!--				<div class="text" v-html="textRemove"></div>-->
<!--			</div>-->
<!--			<div class="dialogFooter">-->
<!--				<div class="buttonGroups">-->
<!--					<v-btn-->
<!--							v-if="isClose"-->
<!--							@click="onClose"-->
<!--							depressed-->
<!--							elevation="2"-->
<!--							color="grey darken-2"-->
<!--					>-->
<!--						{{ textRemoveClose }}-->
<!--					</v-btn>-->
<!--					<v-btn-->
<!--							v-if="isSave"-->
<!--							@click="onSave"-->
<!--							color="success"-->
<!--					>-->
<!--						<span class="btnText">{{ textRemoveSave }}</span>-->
<!--					</v-btn>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
<!--	</v-dialog>-->

	<dialog-slot
			:title="titleRemove"
			@updateClose="onClose"
			:is-cancel-hide="!isClose"
			:cancel-text="textRemoveClose"
			@updateSave="onSave"
			:is-save="isSave"
			:apply-text="textRemoveSave"
			:width="width"
	>
		<div class="text" v-html="textRemove"></div>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "DialogRemove",
	components: { DialogSlot },
	props: {
		titleRemove: String,
		textRemove: String,
		width: {
			type: [ Number, String ],
			default: () => '340'
		},

		textRemoveSave: {
			type: [ String ],
			default: () => 'YES'
		},
		isSave: {
			type: Boolean,
			default: () => true
		},

		textRemoveClose: {
			type: [ String ],
			default: () => 'NO'
		},
		isClose: {
			type: Boolean,
			default: () => true
		},
	},
	data: () => ({
		isDialogRemove: true,
	}),
	methods: {
		onSave() {
			this.$emit('updateRemove');
		},
		onClose() {
			this.$emit('updateCloseRemove');
		},
	},
};
</script>

<style scoped lang="scss">
@import "../../components/Dispatch/Trips/DialogTrip/dialog";
</style>
